/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable jsx-a11y/aria-props */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import classNames from 'classnames';
import lodash from 'lodash';
import React from 'react';

import { SPOILER_TYPE } from './../../ricos-content';
import type { RichContent } from './../../ricos-schema/legacy/wix/rich_content/v1';
import { buildThemeCssVars, THEME_DEFAULTS } from './../../ricos-styles';
import type { NodeViewDecorator, NodeViewRenderers, ViewerContextualData } from './../../ricos-types';
import { AccessibilityListener, getLangDir, GlobalContext } from './../../wix-rich-content-common';

import viewerStyles from '../statics/rich-content-viewer-scss';
import rtlStyles from '../statics/rtl.rtlignore-scss';
import type { ContentViewerProps } from '../types';
import AddAnchors from './components/AddAnchors';
import ContentTraverser from './ContentTraverser';

const styles = { ...viewerStyles, ...rtlStyles };

const ContentViewer: React.FC<ContentViewerProps> = props => {
  const {
    config = {},
    onHover,
    isMobile = false,
    addAnchors,
    onMouseOver = () => {},
    content,
    setRef,
    typeMappers,
    nodeViewRenderers,
    nodeViewDecorators,
    experiments = {},
    t,
  } = props;

  const SpoilerViewerWrapper = config[SPOILER_TYPE]?.SpoilerViewerWrapper;
  const contextualData = getContextualData(props);

  const viewerClassName = classNames(styles.viewer, {
    [rtlStyles.rtl]: contextualData.textDirection === 'rtl',
  });

  const themeWithDefaults = lodash.merge(
    {},
    isMobile ? THEME_DEFAULTS.mobile : THEME_DEFAULTS.desktop,
    contextualData.theme
  );

  const style = buildThemeCssVars(themeWithDefaults, content?.documentStyle ?? {});

  const dataId = { 'data-id': 'content-viewer' };

  return (
    <GlobalContext.Provider key={'RicosViewer'} value={{ experiments, isMobile, t }}>
      <div
        className={classNames(styles.wrapper)}
        dir={contextualData.languageDir}
        onMouseEnter={e => onHover && onHover(e)}
        onMouseOver={onMouseOver}
        ref={setRef}
        style={style}
        {...dataId}
      >
        {props.devTools}
        <div className={viewerClassName}>
          <AddAnchors addAnchors={addAnchors}>
            <ContentTraverser
              content={content as RichContent}
              typeMappers={typeMappers}
              context={contextualData}
              nodeViewRenderers={nodeViewRenderers as NodeViewRenderers}
              nodeViewDecorators={nodeViewDecorators as NodeViewDecorator<JSX.Element>[]}
              SpoilerViewerWrapper={SpoilerViewerWrapper}
            />
          </AddAnchors>
        </div>
        <AccessibilityListener isMobile={isMobile} />
      </div>
    </GlobalContext.Provider>
  );
};

const getContextualData = ({
  t,
  theme,
  isMobile = false,
  anchorTarget,
  relValue,
  customAnchorScroll,
  config,
  locale,
  disabled,
  seoMode,
  iframeSandboxDomain,
  textAlignment,
  experiments,
  textDirection,
  direction,
  helpers,
  onNodeClick,
  jsdomMode,
  baseUrl,
}: ContentViewerProps): ViewerContextualData => {
  return {
    t,
    theme: theme || {},
    isMobile,
    anchorTarget,
    relValue,
    customAnchorScroll,
    config,
    helpers: helpers || {},
    locale: locale || 'en',
    disabled,
    seoMode,
    iframeSandboxDomain,
    disableRightClick: config?.uiSettings?.disableRightClick,
    textAlignment,
    experiments,
    textDirection,
    languageDir: direction || getLangDir(locale),
    onNodeClick,
    jsdomMode,
    baseUrl,
  };
};

export default ContentViewer;
